import { inspectRequestConstants } from "../constants/inspectRequest.constants";

export function inspectRequest(state = {}, action) {
  switch (action.type) {
    case inspectRequestConstants.GET_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case inspectRequestConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };
    case inspectRequestConstants.GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
